if (!customElements.get('sx-infinite-scroll')) {
  customElements.define('sx-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.status = this.querySelector('[role="status"]');
      if (!this.link) return;
      this.link.addEventListener('click', event => { event.preventDefault(); this.load(); });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting) && !this.failed) this.load();
        }, { rootMargin: '0px 0px 250px 0px' });
        this.observer.observe(this);
      }
    }
    async load() {
      if (this.busy || !this.link || !this.isConnected) return;
      this.busy = true;
      this.failed = false;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      this.controller = new AbortController();
      try {
        const url = new URL(this.link.href);
        url.searchParams.set('section_id', this.dataset.section);
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Load failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!this.isConnected) return;
        const grid = this.closest('#ProductGridContainer').querySelector('#product-grid');
        const items = doc.querySelectorAll('#product-grid > li');
        if (!grid || !items.length) throw new Error('No products returned');
        items.forEach(item => {
          item.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
          item.querySelectorAll('img').forEach(img => { img.loading = 'lazy'; });
          grid.append(item);
        });
        const next = doc.querySelector('sx-infinite-scroll a');
        this.status.textContent = this.dataset.loaded;
        if (next) {
          this.link.href = next.href;
          this.observer?.unobserve(this);
          requestAnimationFrame(() => { if (this.isConnected) this.observer?.observe(this); });
        } else {
          this.link.remove();
          this.link = null;
          this.observer?.disconnect();
        }
      } catch (error) {
        if (error.name !== 'AbortError') { this.failed = true; this.status.textContent = this.dataset.error; }
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
  });
}
